import { Api } from '@shared/api';

import { HISTORY_LIMIT } from '../configs';
import type { TokenHistory } from '../types';

export class HistoryApi extends Api {
  public async readAuctionHistory(
    id: string,
    cursor?: string,
    limit: string | number = HISTORY_LIMIT,
  ): Promise<TokenHistory> {
    const cursorParam = cursor ? `&cursor=${cursor}` : '';
    const history = await this.fetch(`${this.baseUrl}/tokens-history?auction_id=${id}&limit=${limit}${cursorParam}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return history.json();
  }
  public async readTokenHistory(
    id: number,
    cursor?: string,
    limit: string | number = HISTORY_LIMIT,
  ): Promise<TokenHistory> {
    const cursorParam = cursor ? `&cursor=${cursor}` : '';
    const history = await this.fetch(`${this.baseUrl}/tokens-history?art_asset_id=${id}&limit=${limit}${cursorParam}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return history.json();
  }
}
